module.exports = __webpack_public_path__ + "img/84-nap-logo.c570a3e2.png";